module.exports = __webpack_public_path__ + "img/category-popular-hover.44521208.png";